module.exports = __webpack_public_path__ + "media/images/icon__info--white-b5ba908bbe17dbf367892203949f1086.png";